module.exports = __webpack_public_path__ + "img/rsz_parkirplac-min.b8959652.jpg";